module.exports = __webpack_public_path__ + "img/contact.0d6c5337.png";